export class Clock {
    constructor(dateConstructor) {
        this.dateConstructor = dateConstructor;
        this.millisecondsInMinute = 60000;
    }
    getBeginningOfTodayForTimeZone(timezone) {
        const currentDate = new this.dateConstructor();
        const delta = this.getDifferenceBetweenCurrentTimezoneAndSelected(currentDate, timezone);
        const currentInTimezone = new Date(currentDate.getTime() + delta);
        currentInTimezone.setHours(0, 0, 0, 0);
        const target = new Date(currentInTimezone.getTime() - delta);
        return target;
    }
    getTimeTillMidnight(timezone) {
        const currentDate = new this.dateConstructor();
        const delta = this.getDifferenceBetweenCurrentTimezoneAndSelected(currentDate, timezone);
        const currentInTimezone = new Date(currentDate.getTime() + delta);
        const midnight = new Date(currentInTimezone);
        midnight.setDate(midnight.getDate() + 1);
        midnight.setHours(0, 0, 0, 0);
        return midnight.getTime() - currentInTimezone.getTime();
    }
    getDifferenceBetweenCurrentTimezoneAndSelected(currentDate, selectedTimezone) {
        const browserTimezoneOffset = -currentDate.getTimezoneOffset() * this.millisecondsInMinute;
        const targetTimezoneOffset = selectedTimezone * 60 * this.millisecondsInMinute;
        return targetTimezoneOffset - browserTimezoneOffset;
    }
}
//# sourceMappingURL=Clock.js.map